import { keyframes } from "@stitches/react"
import { styled, theme } from "@theme/stitches.config"
import * as AccordionPrimitive from "@radix-ui/react-accordion"
import Button from "@components/Button"

export const StyledButton = styled(Button, {
    width: 30,
    height: 30,
    "& svg": {
        width: 8,
        height: 8
    }
})
const slideDown = keyframes({
    from: { height: 0 },
    to: { height: "var(--radix-accordion-content-height)" }
})

const slideUp = keyframes({
    from: { height: "var(--radix-accordion-content-height)" },
    to: { height: 0 }
})

export const ChevronDown = styled("div", {
    width: 24,
    height: 24,
    borderRadius: 9999,
    backgroundColor: theme.colors.backgroundInverse,
    backgroundImage: theme.colors.triangle,
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    transition: "all 200ms ease",
    flexShrink: 0,
    "[data-state=open] &": {
        transform: "rotate(180deg)",
        backgroundColor: theme.colors.effieGold,
        backgroundImage: theme.colors.triangleWhite
    },
    "@mdUp": {
        width: 30,
        height: 30
    }
})

export const StyledAccordion = styled(AccordionPrimitive.Root, {
    border: `1px solid ${theme.colors.effieGold}`,
    borderRadius: 6
})

export const StyledAccordionItem = styled(AccordionPrimitive.Item, {
    overflow: "hidden",
    mt: 1,
    outline: "none",
    borderTop: `1px solid ${theme.colors.effieGold}`,
    "&:first-child": {
        mt: 0,
        borderTop: "none"
    },
    "&:focus-within": {
        position: "relative",
        zIndex: 1
    }
})

export const StyledAccordionHeaderRow = styled(AccordionPrimitive.Header, {
    all: "unset",
    display: "flex"
})

export const StyledAccordionTrigger = styled(AccordionPrimitive.Trigger, {
    all: "unset",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    padding: "25px 20px",
    cursor: "pointer",
    gap: "0 10px",
    "@mdUp": {
        padding: "35px 30px"
    }
})

export const Title = styled("p", {
    fontSizePxToRem: 20,
    fontWeight: theme.fontWeights.semiBold,
    lineHeight: 1.3,
    "@mdUp": {
        fontSizePxToRem: 24,
        lineHeight: 1.25
    }
})

export const StyledAccordionContent = styled(AccordionPrimitive.Content, {
    overflow: "hidden",
    "&[data-state=\"open\"]": {
        animation: `${slideDown} 200ms linear`
    },
    "&[data-state=\"closed\"]": {
        animation: `${slideUp} 200ms linear`
    }
})

export const StyledAccordionContentText = styled("div", {
    padding: "0 20px 20px",
    "@mdUp": {
        padding: "0 50px 25px 25px"
    },
    "@xlUp": {
        padding: "0 70px 30px 30px"
    }
})
